import { Grid } from "@mui/material";
import {
  FunctionField,
  Labeled,
  ReferenceField,
  TextField,
  useRecordContext,
} from "react-admin";
import { administrationRequests } from "api/administrationApi";

const PlaceOfBirth = () => {
  const record = useRecordContext();
  if (!record?.candidate) return null;

  const { birthCountryId, birthSettlementId, birthSettlement } = record.candidate;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <Labeled label="Държава на раждане">
          {birthCountryId ? (
            <ReferenceField
              source="candidate.birthCountryId"
              reference={administrationRequests.getCountriesSelect()}
              link={false}
            >
              <TextField source="nameBg" />
            </ReferenceField>
          ) : (
            <FunctionField render={() => "—"} />
          )}
        </Labeled>
      </Grid>
      <Grid item xs={12} md={4}>
        <Labeled label="Населено място на раждане">
          {birthSettlementId ? (
            <ReferenceField
              source="candidate.birthSettlementId"
              reference={administrationRequests.getSettlementsSelect()}
              link={false}
            >
              <TextField source="nameBg" />
            </ReferenceField>
          ) : (
            <FunctionField render={() => birthSettlement || "—"} />
          )}
        </Labeled>
      </Grid>
    </Grid>
  );
};

export default PlaceOfBirth;
